module.exports = __webpack_public_path__ + "static/media/spiderman.b9838475.png";